/**
 * PageBanner Component
 *
 * Reusable page banner component used for page headers.
 * Features a solid primary color background (theme-aware) with title and subtitle.
 */

import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Box, Typography } from '../ui';

interface PageBannerProps {
  title: any;
  subtitle?: any;
  sx?: any;
  [key: string]: any;
}

const PageBanner: React.FC<PageBannerProps> = ({ title, subtitle, sx, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        padding: { xs: 4, sm: 6, md: 10 },
        paddingTop: { xs: 3, sm: 5, md: 7 },
        paddingBottom: { xs: 3, sm: 5, md: 7 },
        textAlign: 'left',
        width: '100%',
        ...sx,
      }}
      {...props}
    >
      {/* Title inherits the theme's h3 (700 weight, tight negative
          tracking) — no hardcoded font-size override so the typography
          refresh actually shows up here. */}
      <Typography variant="h3" sx={{ color: 'inherit' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h6"
          sx={{
            marginTop: 1.5,
            color: 'inherit',
            fontWeight: 400,
            opacity: 0.9,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageBanner;
